import React, { Component } from "react";
import { TextArea } from "semantic-ui-react";
import ProfilePicture from "../../../../../ProfilePicture";
import { checkIfDesktop } from "../../../../../../util";

class CommentInput extends Component {
  constructor(props) {
    super(props);
    this.state = {
      commentText: props.commentText,
    };
    this.updateValue = this.updateValue.bind(this);
    this.handleSubmitWithKeyboard = this.handleSubmitWithKeyboard.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  handleSubmitWithKeyboard(event) {
    if (event.key === "Enter") {
      if (checkIfDesktop() && !event.shiftKey) {
        event.preventDefault();
        this.handleSubmit();
      }
    }
  }
  updateValue(event) {
    event.preventDefault();
    event.persist();
    if (!event.target) return;
    this.setState(prevState => ({
      ...prevState,
      commentText: event.target.value,
    }));
  }

  handleSubmit() {
    const value = this.state.commentText.trim();
    if (value.length > 0) {
      this.props.onSubmit(value);
    }
    this.setState(prevState => ({
      ...prevState,
      commentText: "",
    }));
  }

  render() {
    const { className = "", getInputRef, user } = this.props;
    return (
      <div className={`comment-input-wrapper ${className}`}>
        {user ? (
          <ProfilePicture
            userId={user.uid}
            size="s"
            fallbackUrl={user.picture}
            className="-comment-user-img"
            alt={user.name}
          />
        ) : null}
        <TextArea
          ref={getInputRef}
          value={this.state.commentText}
          disabled={!user}
          onKeyDown={this.handleSubmitWithKeyboard}
          onChange={this.updateValue}
          placeholder="Leave a comment"
          className="-comment-input"
          autoHeight
        />
        <button className="-comment-reply" onClick={this.handleSubmit}>
          Send
        </button>
      </div>
    );
  }
}

export default CommentInput;



// WEBPACK FOOTER //
// ./src/components/PostsList/components/Interactions/components/CommentInput/index.js